export default __webpack_public_path__ + "a080593d342c830e61da733e8c59d22d.jpg";